module.exports = __webpack_public_path__ + "img/banner.7cc745ab.png";